/**
 * "Owen · SI · Director, Booking Operations". Every byline names the SI
 * leader who wrote the article; the SI badge carries the same disclosure
 * About Us gives them (as its tooltip), so a reader never takes an SI
 * author for a person.
 */
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { AI_AUTHOR_DISCLOSURE } from '@/content/help/authors';

export function SiBadge({ className = '' }) {
  return (
    <span
      title={AI_AUTHOR_DISCLOSURE}
      aria-label="Super intelligence agent"
      className={`inline-flex items-center rounded-full border border-[#7A8ABF]/40 bg-[#7A8ABF]/[0.12] px-1.5 py-[1px] text-[10px] font-medium uppercase tracking-[0.12em] text-[#C9D0EA] ${className}`}
    >
      SI
    </span>
  );
}
SiBadge.propTypes = { className: PropTypes.string };

function formatDate(iso) {
  try { return format(parseISO(iso), 'MMMM d, yyyy'); } catch { return iso; }
}

export default function AuthorByline({ author, updated, minutes, compact = false }) {
  if (!author) return null;
  return (
    <div className="flex items-center gap-3">
      <img
        src={author.portrait}
        alt=""
        loading="lazy"
        className={`${compact ? 'h-9 w-9' : 'h-11 w-11'} rounded-full object-cover object-top ring-1 ring-white/15 bg-white/5`}
      />
      <div className="min-w-0">
        <p className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[14px] text-white">
          <span className="font-medium">{author.name}</span>
          <SiBadge />
          <span className="text-white/55 font-normal">{author.title}</span>
        </p>
        {(updated || minutes) && (
          <p className="mt-0.5 text-[12.5px] font-normal text-white/50">
            {updated && <>Updated {formatDate(updated)}</>}
            {updated && minutes ? ' · ' : ''}
            {minutes ? `${minutes} min read` : ''}
          </p>
        )}
      </div>
    </div>
  );
}
AuthorByline.propTypes = {
  author: PropTypes.object,
  updated: PropTypes.string,
  minutes: PropTypes.number,
  compact: PropTypes.bool,
};
